import { render, staticRenderFns } from "./MedicineKEI.vue?vue&type=template&id=70e1c546"
import script from "./MedicineKEI.vue?vue&type=script&lang=js"
export * from "./MedicineKEI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports